const pageNameKey = "datePicker";

export const datePickerEn = {
  [pageNameKey]: { expirationDateLabel: "Expiration Date" },
};

export const datePickerPtBr = {
  [pageNameKey]: { expirationDateLabel: "Data de validade" },
};

export const datePickerDe = {
  [pageNameKey]: { expirationDateLabel: "Ablaufdatum" },
};

export const datePickerZhHans = {
  [pageNameKey]: {
    expirationDateLabel: "到期日期",
  },
};

export const datePickerIt = {
  [pageNameKey]: { expirationDateLabel: "Data di scadenza" },
};

export const datePickerEs = {
  [pageNameKey]: { expirationDateLabel: "Fecha de vencimiento" },
};

export const datePickerNl = {
  [pageNameKey]: {
    expirationDateLabel: "Vervaldatum",
  },
};

export const datePickerTr = {
  [pageNameKey]: {
    expirationDateLabel: "Son kullanma tarihi",
  },
};
